<template>
  <el-container
    v-if="!loading"
    class="home"
  >
    <!-- 头部 -->
    <el-header>
      <div class="logo">
        <img
        style="margin-top:1rem"
          src="../../assets/image/login/tit55.png"
          alt=""
        >
      </div>
      <div class="header-menu">
        <el-menu
          :default-active="defaultActive"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          background-color="#23c9aa"
          text-color="#fff"
          active-text-color="#ffd04b"
        >
          <!-- :disabled="$route.path != '/indexLabel'" -->
          <el-submenu index="indexLabel" >
            <template slot="title">标签{{labelName}}</template>
            <el-menu-item                     
              v-for="i in labelInfo"
              :key="i.menuCode"
              :index="i.menuCode"
            >{{i.menuName}}</el-menu-item>
          </el-submenu>
          <el-menu-item  index="result">成绩报告</el-menu-item>
          <el-menu-item index="shop">充值</el-menu-item>
          <el-menu-item  index="exchange">兑换</el-menu-item> 
          <!-- <el-menu-item v-for="i in activeLabelInfo" :key="i.menuCode" :index="i.menuCode"></el-menu-item>        -->
        </el-menu>
      </div>
      <div class="logout">
        <img
          :src="userLogo"
          alt=""
        >
        <span class="tearch-name">{{userInfo.userName}}</span> | <span
          class="out"
          @click="logout"
        >退 出</span>
      </div>
    </el-header>
    <!-- 导航栏 和 内容 -->
    <template>
      <router-view></router-view>
    </template>
  </el-container>
</template>

<script>
import { postData, getData, postJson } from "@/http/fetch.js";
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["userInfo", "labelInfo", "loading", "activeLabelInfo"]),
    userLogo() {
      if (this.userInfo.userLogo) {
        return this.userInfo.userLogo;
      } else if (this.userInfo.userSex == "女") {
        return require(`@/assets/image/other/woman_teacher.png`);
      } else if (this.userInfo.userSex == "男") {
        return require(`@/assets/image/other/man_teacher.png`);
      }
    },
    labelName() {
      if (["result", "shop","exchange"].includes(this.activeIndex)) {
        return "";
      } else {
        return (
          " ( " +
          this.labelInfo.find((i) => i.menuCode == this.activeIndex).menuName +
          " ) "
        );
      }
    },
    defaultActive() {
      if (
        this.$route.path == "/indexLabel" ||
        this.$route.path.includes("/setup") ||
        this.$route.path.includes("/evaluate")
      ) {
        return this.labelInfo[0].menuCode;
      } else {
        return this.$route.path.slice(1);
      }
    },
  },
  data() {
    return {
      activeIndex: "",
      beforeCode: "indexLabel,result,shop,exchange",
      firstPath: true,
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      this.$store.commit("loadingStart");
      await this.$store.dispatch("getUserInfo");
      await this.$store.dispatch("getLabelInfo");
      this.$store.commit("loadingFinish");
      this.activeIndex = this.labelInfo[0].menuCode;
      this.$store.commit("setActiveLabel", this.labelInfo[0]);
    },
    handleSelect(key, keyPath) {
      try {
        console.log("key, keyPath", key, keyPath);
        //if (this.firstPath || !this.beforeCode.includes(keyPath[0])) {
        console.log("跳 路由了");
        this.$router.push({ path: "/" + keyPath[0] });
        //}
        this.beforeCode = keyPath[0];
        this.firstPath = false;
        this.activeIndex = key;
        this.$store.commit(
          "setActiveLabel",
          this.labelInfo.find((i) => i.menuCode == key)
        );
      } catch (err) {
        console.log("err", err);
      }
    },
    logout() {
      this.$confirm("亲, 你确认要进行退出么?", "温馨提示", {
        type: "warning",
        confirmButtonClass: "logout-btn",
      })
        .then(() => {
          this.$axios
            .get("/oauth/logout")
            .then((res) => {
              if (res.resultCode === 200) {
                this.$message.success("恭喜, 退出成功");
                localStorage.removeItem("autoLoginObj");
                this.$router.push("/login");
              } else {
                this.$message({
                  message: res.msg,
                  type: "error",
                  duration: 2000,
                  offset: 150,
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  watch: {},
};
</script>

<style lang="less" >
.home {
  height: 100%;
  .el-header {
    background-color: #23c9aa;
    display: flex;
    .logo {
      img {
        height: 40px;
        margin-top: 7px;
      }
    }
    .header-menu {
      font-size: 3rem ;
      flex: 1;
      text-align: center;   
      .el-menu-demo {
        height: 59px;
        padding:0 20px;
        display:inline-block;
        margin: 0 auto;
        padding-left: 55px; 
        .el-menu-item{
        font-size:1.2rem ;
        margin:0 35px 0; 
        text-decoration: none;
        }
        .el-submenu__title{
          font-size:1.2rem;
            text-decoration: none;
        }
             
      }
      
    }
    .logout {
      height: 58px;
      font-size: 15px;
      text-align: left;
      line-height: 58px;
      color: #fff;
      .tearch-name {
        margin-right: 5px;
      }
      .out {
        margin-left: 5px;
        cursor: pointer;
      }
      img {
        margin-right: 8px;
        margin-bottom: 3px;
        width: 35px;
        // height: 35px;
        border-radius: 50%;
        vertical-align: middle;
      }
    }
  }
}
.el-menu.el-menu--horizontal{
  border-bottom: none;
}
</style>
